import { toMoment } from 'api/helpers';
import OrderType from './OrderType';
import he from 'he';

export default class Product {
	id = null;
	image_url = null;
	name = '';
	db_item_name = '';
	number = '';
	start_date = '';
	quantity = null;
	list_price = 0;
	promo = null;
	ta = 0;
	net_price = 0;
	est_ship_date = null;
	est_ship_date_for_cart = null;
	invoice_hold_weeks = 0;
	order_type = null;
	is_drop_ship = '';
	promotion_id = 0;
	category_id = 0;
	pack_id = 0;
	is_pack = false;
	is_configurable = false;
	is_preview = false;
	currency_symbol = '';
	country_short_name = '';
	promotion_name = '';
	end_date = '';
	category_end_date = '';
	category_id = 0;
	category_name = '';
	promo_price = 0;
	promotion_end_date = '';
	promotion_name = '';
	base_number = '';
	total_config_qty_ordered = 0;
	category_promotion_class_id = 0;
	quantity_available = 0;
	promo_no_of_days = null;
	pack_name = null;
	price_list = null;
	item_description = '';
	category_ship_type_id = 0;
	category_ship_type_name = '';

	constructor(product) {
		this.id = product.Id;
		this.image_url = product.ImageUrl;
		this.name = he.decode(product.Name);
		this.db_item_name = product.Name;
		this.number = product.Number;
		this.start_date = toMoment(product.StartDate);
		this.quantity = product.Quantity;
		this.list_price = product.ListPrice;
		this.promo = product.PromoPrice;
		this.ta = product.TA;
		this.net_price = product.NetPrice;
		this.est_ship_date = toMoment(product.EstShipDate);
		this.est_ship_date_for_cart = toMoment(product.EstShipDateForCart);
		this.invoice_hold_weeks = product.OrderType.HoldInvoiceWeeks;
		this.order_type = new OrderType(product.OrderType);
		this.is_drop_ship = product.IsDropShipAllowed;
		this.promotion_id = product.PromotionId;
		this.category_id = product.CategoryId;
		this.pack_id = product.PackId;
		this.is_pack = product.IsPack;
		this.is_configurable = product.IsConfigurable;
		this.is_preview = product.IsPreview;
		this.promotion_name = product.PromotionName;
		this.end_date = toMoment(product.EndDate);
		this.currency = {
			currency_symbol: product.CurrencySymbol,
			country_short_name: product.CountryShortName,
		};
		this.category_end_date = toMoment(product.CategoryEndDate);
		this.category_name = product.CategoryName;
		this.promo_price = product.PromoPrice;
		this.promotion_end_date = toMoment(product.PromotionEndDate);
		this.promotion_name = product.PromotionName;
		this.base_number = product.BaseNumber;
		this.total_config_qty_ordered = product.TotalConfigQtyOrdered;
		this.category_promotion_class_id = product.CategoryPromotionClassId;
		this.quantity_available = product.QuantityAvailable;
		this.promo_no_of_days = product.PromoNoOfDays;
		this.pack_name = product.IsPack ? product.PackName : null;
		this.price_list = product.PriceList;
		this.item_description = product.ItemDescription;
		this.category_ship_type_id = product.CategoryShipTypeId;
		this.category_ship_type_name = product.CategoryShipTypeName;
	}
}



// WEBPACK FOOTER //
// ./src/api/models/Product.js